<template>
    <section class="loading-overlay flex flex-wrap justify-content-center align-content-center">
        <div class="loading-container">
            <!-- <h1 class="text-center loading-title">Delivering your order, please wait...</h1> -->
            <img 
                src="@/assets/images/icons/city.png"
                class="warehouse-image"
                style="left: 20px; "
                />
            <img 
                src="@/assets/images/icons/fleet.svg" 
                class="loading-truck-animation truck-image"
                />
            <img 
                src="@/assets/images/icons/city.png"
                class="warehouse-image"
                style="right: 20px;"
                />
        </div>
    </section>
</template>


<script>
    export default {
        name: "LoadingOverlay",
    }
</script>